// extracted by mini-css-extract-plugin
export default {"tag":"tag-module___tag___c290c542","highlight":"tag-module___highlight___c9d79730","default":"tag-module___default___ac168fba","error":"tag-module___error___b3608e0e"};